
export const menu = [
    {
        id: 1,
        title: '회사소개',
        url: '#',
        icon: 'BusinessRoundedIcon',
        submenu: [
            {subtitle: '인사말', url: '/greeting'},
            // {subtitle: '조직도', url: ''},
            {subtitle: '오시는길', url: '/directions'}
        ]
    },
    {
        id: 2,
        title: '사업소개',
        url: '#',
        icon: 'BusinessCenterRoundedIcon',
        submenu: [
            {subtitle: '안전관리업무위탁', url: '/content_01'},
            {subtitle: '안전관리기술지도', url: '/content_02'},
            {subtitle: '유해위험방지계획서', url: '/content_03'},
            {subtitle: '위험성평가', url: '/content_04'},
            {subtitle: '공정안전보고서', url: '/content_05'},
            {subtitle: '자율안전확인신고', url: '/content_06'},
            {subtitle: '근골격계유해요인조사', url: '/content_07'},
            {subtitle: 'ISO 45001 인증', url: '/content_08'},
            {subtitle: 'KOSHA-MS 인증', url: '/content_09'},
        ]
    },
    // {
    //     id: 3,
    //     title: '고객지원',
    //     url: '#',
    //     submenu: [
    //         {subtitle: 'sub1', url: ''}
    //     ]
    // }
]